<template>
<div class="statisticEmployeeCardList" >
  <div class="statisticEmployeeCardList__wrapper" v-if="employees.length > 0">
		<carousel
			:per-page="1"
			:mouse-drag="false"
			:autoplay="true"
			:autoplayHoverPause="true"
			:autoplayTimeout="10000"
			:loop="true"
			:perPageCustom="[[320, 1], [1280, 3]]"
			:mouseDrag="true">
			<slide
				v-for="(employee, index) in employees"
				v-bind:key="index"
				:index="index">
				<div class="statisticEmployeeCardList__item statisticEmployeeCard">
					<div class="statisticEmployeeCard__nameInfo">
						<div class="statisticEmployeeName" v-bind:class="{'statisticEmployeeName_leader': employee.statistics.leader}">
							{{ employee.info.name }} {{ employee.info.lastName }}
						</div>
					</div>
					<div class="statisticEmployeeCard__totalChart" id="chart">
						<apexchart class="radialChart radialChart_center"
							type="radialBar"
							height="300"
							width="200"
							:options="chartOptions"
							:series="[employee.statistics.percent.total]"
						/>
					</div>

					<div class="statisticEmployeeCard__progressBarList">
						<div class="statisticEmployeeCard__progressBarWrapper progressBarWrapper">
							<div class="progressBarWrapper__label">Звонки: {{ employee.statistics.raw.calls.today.countSum }} ({{ employee.statistics.callsDurationTime }})</div>
							<progress-bar
								class="progressBarWrapper__bar progressBar progressBar_theme_default progressBar_icon progressBar_icon_phone"
								v-bind:class="setClassColorProgressBar(employee.statistics.percent.calls)"
								:options="progressBarOptions"
								:value="employee.statistics.percent.calls"
							/>
						</div>

						<div class="statisticEmployeeCard__progressBarWrapper progressBarWrapper">
							<div class="progressBarWrapper__label">Сумма сделок: {{ employee.statistics.raw.deals.today.priceSum }} руб.</div>
							<progress-bar
								class="progressBarWrapper__bar progressBar progressBar_theme_default progressBar_icon progressBar_icon_coins"
								v-bind:class="setClassColorProgressBar(employee.statistics.percent.deals)"
								:options="progressBarOptions"
								:value="employee.statistics.percent.deals"
							/>
						</div>

						<div class="statisticEmployeeCard__progressBarWrapper progressBarWrapper">
							<div class="progressBarWrapper__label">ЦКП сегодня: {{ employee.statistics.raw.invoices.today.priceSum }} рублей </div>
							<progress-bar
								class="progressBarWrapper__bar progressBar progressBar_theme_default progressBar_icon progressBar_icon_coins"
								v-bind:class="setClassColorProgressBar(employee.statistics.percent.invoices)"
								:options="progressBarOptions"
								:value="employee.statistics.percent.invoices"
							/>
						</div>
					</div>

					<div class="statisticEmployeeCard__dataRows">
						<hr />
						<div class="statisticEmployeeCard__dataRow">ЦКП фин. недели: {{ employee.statistics.raw.invoices.finWeek.priceSum }} рублей </div>
						<div class="statisticEmployeeCard__dataRow">ЦКП месяца игры: {{ employee.statistics.raw.invoices.playMonth.priceSum }} рублей</div>
						<div class="statisticEmployeeCard__dataRow">ЦКП года: {{ employee.statistics.raw.invoices.year.priceSum }} рублей</div>
					</div>
				</div>
		</slide>
	</carousel>
	</div>
</div>
</template>

<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import ProgressBar from "vuejs-progress-bar";
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    apexchart: VueApexCharts,
    progressBar: ProgressBar,
		Carousel,
		Slide
  },
  data: function () {
    return {
      chartOptions: {
        chart: {
          offsetY: -20,
          foreColor: "#797d7d"
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#f1f1f1",
              strokeWidth: "99%",
              margin: 5, // margin is in pixels
              shadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#fff",
                opacity: 1,
                blur: 2
              }
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: -2,
                fontSize: "32px"
              }
            }
          }
        },
        fill: {
          colors: [
            function({ value }) {
              if (value < 55) {
                //return "#D9534F";
                return "#ec120c";
              } else if (value >= 55 && value < 100) {
                //return "#bee038";
                return "#fdf30c";
                //return "#64ad1f";
              } else {
                return "#38e041";
              }
            }
          ],
          type: "gradient",
          gradient: {
            shade: "light",
            shadeIntensity: 0.2,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91]
          }
        },
        labels: ["Average Results"]
      },
      progressBarOptions: {
        text: {
          color: '#0a0a0a',
          shadowEnable: false,
          shadowColor: '#000000',
          fontSize: 14,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: false
        },
        progress: {
          color: '#2dbd2d',
          backgroundColor: '#f1f1f1'
        },
        layout: {
          height: 25,
          width: 280,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      },
    }
  },
  methods: {
    setClassColorProgressBar(value) {
      let color = "fail";
      if(value > 55 && value < 100) {
        color = "normal";
      } else if(value >= 100) {
        color = "success";
      }
      return 'progressBar_color_' + color;
    },
    setColorProgressBar(options, value) {
      let color = "#D9534F";
      if(value > 55 && value < 100) {
        color = "#bee038";
      } else if(value >= 100) {
        color = "#38e041";
      }
      options.progress.color = color;
      return options;
    },
  },
	name: "MonitorEmployeesRow",
  props: {
    employees: Array
  }
};
</script>



// WEBPACK FOOTER //
// src/components/monitor/MonitorEmployeesRow.vue